import {
    CreateBlockVueDomV3,
    createRecord,
    CreateWidgetFromFirebaseNode
} from "../components/v3/lib/vue-dom-obj";
import { Command } from "./Command";


export class PageEngineCommands extends Command {
    _pageEngineComponent = null

    get clonedVDom () {
        return this._pageEngineComponent.clonedVDom
    }

    set clonedVDom (value) {
        this._pageEngineComponent.clonedVDom = value
    }

    addBlock (key, sectionNode, idx=null) {
        if (idx) {
            this.clonedVDom.splice(idx, 0, {key: key, node: sectionNode})
            return
        }
        this.clonedVDom.push({key: key, node: sectionNode})
    }

    removeBlock (key) {
        this.clonedVDom = this.clonedVDom.filter(x => x.key !== key)
    }

    addBlockAtPosition (key, sectionNode, idx = -1) {
        if (idx !== -1) {
            this.clonedVDom.splice(idx, 0, {key: key, node: sectionNode})
        }
    }

    replaceBlockAtPosition (key, sectionNode, idx = -1) {
        if (idx !== -1) {
            this.clonedVDom.splice(idx, 1, {key: key, node: sectionNode})
        }
    }

    get fbNode() {
        return this._pageEngineComponent.fbNode
    }

    get firebaseRef () {
        return this._pageEngineComponent.firebaseRef()
    }

    get $nextTick () {
        return this._pageEngineComponent.$nextTick
    }

    get $children() {
        return this._pageEngineComponent.$children
    }
}
/**
 * Handles Section Add Actions
 */
export class AddSectionCommand extends PageEngineCommands {
    constructor(pageEngineComponent, sectionNode) {
        super();
        this._pageEngineComponent = pageEngineComponent
        this._widget = CreateWidgetFromFirebaseNode(sectionNode, true)
        // _addedGridStackNodeElement: for the purpose of redo and undo,
        // we want to track already created vueElement, just in case they are part of another undo or redo action
        this._addedGridStackNodeElement = null
        this._nodeRemoved = false
    }

    get hasChanges () {
        return true
    }

    async execute() {
        this.firebaseRef.push(this._widget).then((value) => {
            let newRecord = null
            if (this._addedGridStackNodeElement !== null) {
                // use existing record if reverted
                newRecord = this._addedGridStackNodeElement.fbNode
                this._nodeRemoved = false
            }
            else {
                const gridContainerNode = createRecord(value.snapshot)
                const children = gridContainerNode.children || gridContainerNode['.value']
                let key = children.length
                newRecord = CreateBlockVueDomV3(
                    children[key - 1], `${key - 1}`, gridContainerNode['.path']
                )
            }
            this.addBlock(newRecord.data.props.vnodeId, newRecord)
            this.$nextTick(() => {
                this._addedGridStackNodeElement = this.$children[this.$children.length - 1]
                this._addedGridStackNodeElement.$el.scrollIntoView({
                    behavior: 'smooth',
                })
                this._pageEngineComponent.$mount()
            })
        })
    }

    async unExecute() {
        if (this._addedGridStackNodeElement && !this._nodeRemoved) {
            this.removeBlock(this._widget.data.props.vnodeId)
            await this.firebaseRef.removeNode(this._addedGridStackNodeElement.idx())
            this._pageEngineComponent.$mount()
            this._nodeRemoved = true
        }
    }
} 